import axios from 'axios';
import { BASE_PATH_SERVER } from './config';

// API client de tenant_texts. Migrado a axios: Authorization + retry 401 vía
// interceptor global. El primer parámetro `_token` se conserva (ignorado) para
// no correr las posiciones de los callers existentes; lo inyecta el interceptor.

// Contrato preservado: estas funciones NUNCA rechazan — ante error (incl. 4xx)
// devuelven { status:'client', ... } con el message del backend si lo hay.
const catchErr = (err) => ({
  status: 'client',
  codeMessage: 'ERROR_EN_LA_PETICION',
  message: err?.response?.data?.message || err?.message,
});

// GET /tenants/:tenantId/texts/by-document-type?documentType=...
export const getTenantTextsByDocumentTypeApi = async (_token, tenantId, documentType) => {
  try {
    const { data } = await axios.get(
      `${BASE_PATH_SERVER}tenants/${tenantId}/texts/by-document-type`,
      {
        params: { documentType },
      }
    );
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

// POST /tenants/texts — crear fila con { tenantId, keyName, textValue, documentType }
export const createTenantTextApi = async (_token, payload) => {
  try {
    const { data } = await axios.post(`${BASE_PATH_SERVER}tenants/texts`, payload);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

// PUT /tenants/:tenantId/texts/:textId — actualiza fila
export const updateTenantTextApi = async (_token, tenantId, textId, patch) => {
  try {
    const { data } = await axios.put(
      `${BASE_PATH_SERVER}tenants/${tenantId}/texts/${textId}`,
      patch
    );
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

// DELETE /tenants/:tenantId/texts/:textId
export const deleteTenantTextApi = async (_token, tenantId, textId) => {
  try {
    const { data } = await axios.delete(`${BASE_PATH_SERVER}tenants/${tenantId}/texts/${textId}`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};
